if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        
        this.initDesktopLayout();
      }

      connectedCallback() {
        this.initDesktopLayout();
      }

      initDesktopLayout() {
        if (window.innerWidth < 750) return;
        const viewer = this.elements.viewer;
        const thumbnails = this.elements.thumbnails;
        if (!viewer || !thumbnails) return;

        // Move thumbnails left
        if (this.firstElementChild !== thumbnails) {
          this.insertBefore(thumbnails, viewer);
        }

        // Apply styles to thumbnail list
        const thumbList = thumbnails.querySelector('.thumbnail-list');
        if (thumbList) {
          thumbList.style.display = 'flex';
          thumbList.style.flexDirection = 'column';
          thumbList.style.gap = '10px';
          thumbList.style.maxHeight = '580px';
          thumbList.style.overflowY = 'auto';
          thumbList.style.scrollBehavior = 'smooth';
          thumbList.style.scrollbarWidth = 'none';
          thumbList.style.msOverflowStyle = 'none';
        }

        // Fix individual thumbs
        thumbnails.querySelectorAll('.thumbnail-list__item').forEach(item => {
          item.style.width = '80px';
          item.style.maxWidth = '80px';
          item.style.height = '80px';
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);

        // DOTS ACTIVE
        const slides = [...this.elements.viewer.querySelectorAll('.slider__slide')];
        const currentIndex = slides.indexOf(event.detail.currentElement);

        document.querySelectorAll('.slider-counter__link').forEach((dot, index) => {
          if (index === currentIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        
        // Ensure styling applies after prepend/update
        this.initDesktopLayout();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (window.innerWidth >= 750) {
          const slider = this.elements.thumbnails.slider;
          const sliderTop = slider.scrollTop;
          const sliderBottom = sliderTop + slider.clientHeight;
          
          // Calculate thumbnail top position relative to the slider container
          const thumbnailTop = thumbnail.getBoundingClientRect().top - slider.getBoundingClientRect().top + slider.scrollTop;
          const thumbnailBottom = thumbnailTop + thumbnail.clientHeight;

          if (thumbnailTop < sliderTop) {
            slider.scrollTo({ top: thumbnailTop, behavior: 'smooth' });
          } else if (thumbnailBottom > sliderBottom) {
            slider.scrollTo({ top: thumbnailBottom - slider.clientHeight, behavior: 'smooth' });
          }
        } else {
          if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider-counter__link').forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const slides = document.querySelectorAll(
        '.product__media-list .slider__slide'
      );

      if (slides[index]) {
        slides[index].scrollIntoView({
          behavior: 'smooth',
          inline: 'start'
        });
      }
    });
  });
});
// Mobile auto-slider disabled as requested by the user